var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"message"}},[_c('div',{staticClass:"content-message"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_c('p',[_vm._t("default")],2)])]),_c('footer',[_vm._t("footer",function(){return [_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v("Voltar para o login")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }